// Keep in sync with benchling/llm/deep_research/utils.py

export const DEEP_RESEARCH_EMAIL_NOTIFICATION_ENABLED_PREFERENCE_KEY =
  'llm.deep-research.email-notification-enabled';
export const DEFAULT_DEEP_RESEARCH_EMAIL_NOTIFICATION_ENABLED = true;
